<template>
    <card>
        <div slot="header">
            <h4 class="float-left">{{ title }}</h4>
            <base-button round type="primary" size="sm" class="float-right">{{ subtitle }}</base-button>
        </div>

        <div class="row" v-if="temporaryMessage !== false">
            <div class="col-12">
                <h4>You have a temporary recording.</h4>
                <vue-plyr
                    :options="{'controls': [ 'play','progress','current-time', 'download']}">
                    <audio preload="none">
                        <source :src="temporaryMessage.file" type="audio/wav"/>
                    </audio>
                </vue-plyr>
                <base-button class="right" :loading="uploadingTemporaryMessage"
                             @click="saveTemporaryMessage" type="primary">
                    Save
                </base-button>
                <base-button icon @click="removeTemporaryMessage" type="danger"
                             :loading="removing[temporaryMessage.id]" class="right">
                    <font-awesome-icon v-show="!removing[temporaryMessage.id]"
                                       :icon="['fal','trash']"></font-awesome-icon>
                </base-button>
            </div>
        </div>

        <div class="row table-full-width">
            <div class="col-sm-12">
                <el-table
                    :data="messages"
                    v-loading="loadingMessages"
                    max-height="170"
                    size="small">
                    <el-table-column prop="number" label="#" min-width="30">
                    </el-table-column>
                    <el-table-column min-width="150" label="Player">
                        <template slot-scope="scope">
                            <vue-plyr :options="{'controls': ['play', 'progress', 'current-time', 'download']}">
                                <audio preload="none" >
                                    <source :src="scope.row.file" type="audio/wav"/>
                                </audio>
                            </vue-plyr>
                        </template>

                    </el-table-column>
                    <el-table-column min-width="90" label="Date">
                        <template slot-scope="scope">
                            {{ moment.unix(scope.row.timestamp).format('YYYY-MM-DD HH:mm') }}
                        </template>

                    </el-table-column>
                    <el-table-column
                        header-align="right"
                        align="right"
                        min-width="80"
                        label="Actions">
                        <div slot-scope="{ row,$index  }" class="text-right table-actions">
                            <base-button
                                v-if="row.number !== messages.length && messages.length > 1"
                                v-on:click="moveMessage(row.number,'up')"
                                type="info"
                                icon
                                size="sm"
                                class="btn-link">
                                <font-awesome-icon :icon="['fal','arrow-up']"></font-awesome-icon>
                            </base-button>
                            <base-button
                                v-if="row.number !== 1 && messages.length > 1"
                                v-on:click="moveMessage(row.number,'down')"
                                type="info"
                                icon
                                size="sm"
                                class="btn-link">
                                <font-awesome-icon :icon="['fal','arrow-down']"></font-awesome-icon>
                            </base-button>
                            <base-button
                                v-on:click="removeMessage(row.number)"
                                type="danger"
                                icon
                                size="sm"
                                class="btn-link">
                                <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
                            </base-button>

                        </div>
                    </el-table-column>
                    <div slot="empty">
                        <span>You have no messages.</span>
                    </div>
                </el-table>
                <hr>
                <h5>Upload new message </h5>
                <el-upload
                    class="custom-control-inline"
                    ref="upload"
                    :multiple="false"
                    accept="audio/*"
                    :limit="1"
                    :auto-upload="false"
                    :on-change="setMessageToUpload"
                    action="">
                    <base-button type="info" slot="trigger" size="small">Browse...</base-button>
                </el-upload>
                <base-button class="right" :loading="uploading" :disabled="!recording"
                             @click="upload" type="primary">
                    Upload
                </base-button>
            </div>
        </div>
    </card>
</template>
<script>
    import axios from "axios";
    import swal from 'sweetalert2';

    export default {
        name: 'hotline-card',
        props: {
            title: String,
            subtitle: String,
            resourceUrl: String,
        },
        data() {
            return {
                messages: [],
                loadingMessages: true,
                recording: null,
                uploading: false,
                uploadingTemporaryMessage: false,
                temporaryMessage: false,
                removing: {},
                windowWidth: window.innerWidth
            }
        },
        mounted() {
            this.loadMessages();
            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        },
        methods: {
            loadMessages() {
                this.loadingMessages = true;
                axios({
                    url: this.resourceUrl, method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.messages = resp.data.data;
                }).finally(() => {
                    this.$forceUpdate();
                    this.loadingMessages = false;
                });
            },
            removeMessage(number) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You're about to delete a message. It's the " + number + 'th message.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.loadingMessages = true;
                        axios({
                            url: this.resourceUrl + number,
                            method: 'DELETE',
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Content-Type': 'application/json',
                            },
                        }).then(() => {
                            this.$notify({
                                message: 'Message removed!',
                                type: "success",
                                icon: "fal fa-trash",
                                title: "Removed!"
                            });
                        })
                            .finally(() => {
                                this.loadMessages();
                            })
                    }
                });


            },
            moveMessage(number, direction) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You're about to move this message. It's the " + number + 'th message.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, move it!'
                }).then((result) => {
                    if (result.value) {
                        this.loadingMessages = true;
                        axios({
                            url: this.resourceUrl + number + '/move/' + direction,
                            method: 'POST',
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Content-Type': 'application/json',
                            },
                        }).then(() => {
                            this.$notify({
                                message: 'Message moved!',
                                type: "success",
                            });
                        })
                            .finally(() => {
                                this.loadMessages();
                            })
                    }
                });


            },
            setMessageToUpload(file, filelist) {
                this.recording = file.raw;
            },
            upload() {
                this.uploading = true;
                let formdata = new FormData();

                if (this.recording != null) {
                    formdata.append('message', this.recording);
                }

                axios.post(this.resourceUrl,
                    formdata, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'multipart/form-data',
                        },
                    }).then(() => {
                    this.$notify({
                        message: 'Message uploaded!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Uploaded!"
                    });

                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Failed to upload. Probably too large or incorrect file type!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.uploading = false;
                    this.loadMessages();

                    //    Clear file in file uploader
                    this.$refs['upload'].clearFiles()
                });
            },
            loadTemporaryMessage() {
                this.loadingTemporaryMessage = true;
                axios({
                    url: this.resourceUrl + 'temporary',
                    method: 'GET',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    if (resp.status !== 204) {
                        this.temporaryMessage = resp.data.data;
                    }
                }).catch(resp => {
                    this.temporaryMessage = false;
                }).finally(() => {
                    this.loadingTemporaryMessage = false;
                });
            },
            removeTemporaryMessage() {
                let school = this.temporaryMessage.id;
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$set(this.removing, school, true);
                        axios({
                            url: this.resourceUrl + 'temporary',
                            method: 'DELETE',
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Content-Type': 'application/json',
                            },
                        }).then(resp => {
                            this.temporaryMessage = false
                        }).finally(() => {
                            this.$set(this.removing, school, false);
                        });
                    }
                });
            },
            saveTemporaryMessage() {
                this.uploadingTemporaryMessage = true;
                axios({
                    url: this.resourceUrl + 'temporary',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.temporaryMessage = false
                }).finally(() => {
                    this.uploadingTemporaryMessage = false;
                    this.loadMessages();
                });
            },
        },
        watch: {
            resourceUrl: function (newVal, oldVal) { // watch it
                if (newVal.includes('undefined')) {
                    //    Do nothing, wait until it's a valid string.
                    return;
                }

                this.loadMessages();
                this.loadTemporaryMessage();
            }
        }
    }
</script>
<style scoped>
    .el-table .table-actions .btn {
        margin-right: 0;
    }
</style>
